import { UseFormReturn, useFormContext } from "react-hook-form";

const WrapWithFormContext = ({ children }: { children: (methods: UseFormReturn) => any }) => {
    const methods = useFormContext();

    return children(methods);
};

export default WrapWithFormContext;
